import { loadBaseCSS } from '../shared/button-utils.js';
import { upgradeProperty } from '../shared/form-control.js';
import { primitiveStyles } from '../shared/primitive-utils.js';

/**
 * Content panel owned by a direct qds-tabs parent; preserves content while hidden.
 * @element qds-tab-panel
 * @attr {string} value - Stable identity matching its tab.
 * @property {string} value - Stable panel identity.
 * @slot default - Arbitrary panel content, including nested tabs.
 * @csspart content - Content wrapper.
 */
export class QdsTabPanel extends HTMLElement {
  static get observedAttributes(): string[] { return ['value']; }
  constructor() {
    super();
    this.attachShadow({ mode: 'open' }).innerHTML = `<style>${primitiveStyles}
      :host { display: block; min-width: 0; padding: var(--theme-space-4, 16px) 0; }
    </style><div part="content"><slot></slot></div>`;
    loadBaseCSS();
  }
  connectedCallback(): void {
    upgradeProperty(this, 'value');
    if (!this.hasAttribute('slot')) this.slot = 'panel';
    this.setAttribute('role', 'tabpanel');
    if (!this.hasAttribute('tabindex')) this.tabIndex = 0;
  }
  attributeChangedCallback(): void { /* The owner observes identity changes. */ }
  get value(): string { return this.getAttribute('value') || ''; }
  set value(value: string) { this.setAttribute('value', value ?? ''); }
}
if (!customElements.get('qds-tab-panel')) customElements.define('qds-tab-panel', QdsTabPanel);
